import {
  CastingTestReportStateTypes,
  CastingTestReportActionTypes,
} from "./CastingTestReport.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: CastingTestReportStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const CastingTestReportReducer = (
  state: CastingTestReportStateTypes = INITIAL_STATE,
  action: any
): CastingTestReportStateTypes => {
  switch (action.type) {
    case CastingTestReportActionTypes.FETCH_ALL_CASTING_TEST_REPORT:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case CastingTestReportActionTypes.FETCH_ALL_CASTING_TEST_REPORT_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case CastingTestReportActionTypes.FETCH_ALL_CASTING_TEST_REPORT_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case CastingTestReportActionTypes.FETCH_ALL_CASTING_TEST_REPORT_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case CastingTestReportActionTypes.FETCH_ONE_CASTING_TEST_REPORT:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case CastingTestReportActionTypes.FETCH_ONE_CASTING_TEST_REPORT_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case CastingTestReportActionTypes.FETCH_ONE_CASTING_TEST_REPORT_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case CastingTestReportActionTypes.FETCH_ONE_CASTING_TEST_REPORT_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default CastingTestReportReducer;
